jQuery(document).ready(function ($) {
  const passwordField = $("#wachtwoord");
  const orgDataElement = document.getElementById("org-data");
  const organisations = JSON.parse(orgDataElement.textContent);

  // Check if user already logged in
  const savedPassword = sessionStorage.getItem("OrganisationPassword");
  const $startOrder = $("#startOrder");
  const $noAccess = $("#noAccessMessage");

  if (savedPassword) {
    const match = organisations.find((org) => org.password === savedPassword);
    const storedOrgName = sessionStorage.getItem("OrganisationName");
    if (storedOrgName) {
      $("#orgName").text(storedOrgName);
    }
    if (match) {
      $startOrder.removeClass("hidden");
      $noAccess.hide();
    } else {
      $startOrder.hide();
      $noAccess.show();
    }
  } else {
    $startOrder.hide();
    $noAccess.show();
  }

  // Reset alert on input
  passwordField.on("input", function () {
    $(this).removeClass("show-alert");
  });

  // Handle login
  $("#checkPass").on("click", function (e) {
    e.preventDefault();
    const inputValue = passwordField.val().trim();
    const match = organisations.find((org) => org.password === inputValue);

    if (match) {
      sessionStorage.setItem("OrganisationID", match.orgID);
      sessionStorage.setItem("OrganisationName", match.orgName);
      sessionStorage.setItem("OrganisationPassword", inputValue);
      sessionStorage.setItem("OrganisationEmail", match.orgEmail);
      passwordField.val("");

      window.location.href = "/order";
    } else {
      passwordField.addClass("show-alert");
    }
  });

  // start ordering
  $('.btn-pink:contains("Starten")').on("click", function (e) {
    e.preventDefault();

    $(".welcome-message").addClass("hidden");
    $(".get-started").removeClass("hidden");
  });
});
